import { Typography } from "antd"

import { RichText } from "./RichText"

import styles from "../CreditsAutomationConnectGuide.module.less"

const { Text } = Typography

const SUB_STEP_LETTERS = "abcdefghijklmnopqrstuvwxyz"

const SubSteps = ({ items, ordered, linkHref, variables }) => (
  <div className={styles.subSteps}>
    {items.map((item, index) => (
      <div key={index} className={styles.step}>
        <Text type="secondary" className={styles.marker}>
          {ordered ? `${SUB_STEP_LETTERS[index]}.` : "•"}
        </Text>
        <Text type="secondary" className={styles.stepText}>
          <RichText text={item} linkHref={linkHref} variables={variables} />
        </Text>
      </div>
    ))}
  </div>
)

export const StepList = ({ steps, linkHref, variables }) => (
  <div className={styles.stepList}>
    {steps.map((step, index) => (
      <div key={index} className={styles.step}>
        <Text type="secondary" className={styles.marker}>
          {index + 1}.
        </Text>
        <div className={styles.stepContent}>
          <Text type="secondary" className={styles.stepText}>
            <RichText text={step.text} linkHref={linkHref} variables={variables} />
          </Text>
          {step.subSteps && (
            <SubSteps
              items={step.subSteps}
              ordered={step.ordered !== false}
              linkHref={linkHref}
              variables={variables}
            />
          )}
        </div>
      </div>
    ))}
  </div>
)
